import BaseEntity           from '@/core/misc/BaseEntity';
import SWPortalTasksService from "@/domains/SWPortalTask/SWPortalTasksService";
import Core                 from '@/core/Core';

import type TransportOrder from '@/domains/TransportOrders/TransportOrder';
import Title_ru_RU_Class from "@/core/misc/decorators/Title_ru_RU_Class";

@Title_ru_RU_Class('Задача на корпоративном портале')
class SWPortalTask extends BaseEntity {

    static Events = {
      Created: 'swPortalTask:created',
    } as const;

    public transportOrder: TransportOrder;
    public taskBody: string;

    public performers: any[] = SWPortalTasksService.getPerformers(true);
    public watchers: any[] = SWPortalTasksService.getWatchers(true);

    public content: string;
    public title: string;

    /** Флаг для слайдера исполнителей и наблюдателей по умолчанию */
    private _isFromMoscowSellers: boolean = true;

    /** Приоритет задачи КП */
    public priority: string;

    static fromTransportOrder(transportOrder: TransportOrder): SWPortalTask {
        const result = new this();
        result.transportOrder = transportOrder;
        result.isFromMoscowSellers = true;

        /** Нам нужен зтк только при создании заголовка, потом нужно от него избавиться
         * оставив только айдишник */
        result.updateTitle();

        return result;
    }

    updateTitle() {
        try {
            const {
                id,
                createdAt,
                senderCompany,
                pickupDatePlanned,
            } = this.transportOrder;

            this.title = `Отгрузка ${senderCompany.name} ${Core.utils.date.format(pickupDatePlanned)} (ЭТП${this.transportOrder.isOfferBased === false ? ' по прямой сделке' : ''}),`
                + `${id ? ` ЗТК №${id}` : ''} от ${Core.utils.date.format(createdAt || new Date())}`;
        } catch (error) {
            Core.showNotification.error('Произошла ошибка при формировании заголовка задачи');
        }
    }

    /** Суть в том что от тумблера зависит набор исполнителей и наблюдателей */
    get isFromMoscowSellers(): boolean {
        return this._isFromMoscowSellers;
    }

    set isFromMoscowSellers(value: boolean) {
        this._isFromMoscowSellers = value;

        this.performers = SWPortalTasksService.getPerformers(value);
        this.watchers = SWPortalTasksService.getWatchers(value);
    }
}

export default SWPortalTask;
